import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "../locals/fr.json";
import ar from "../locals/ar.json";
import en from "../locals/en.json";

const resources = {
    fr: {
        translation: fr
    },
    ar: {
        translation: ar
    },
    en: {
        translation: en
    }
};

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        detection: {
            lookupLocalStorage: "lang"
        },
        resources,
        fallbackLng: "fr",
        interpolation: {
            escapeValue: false 
        }
    });

let currentLang = localStorage.getItem("lang");
if(!currentLang || currentLang === 'en-US'){
    localStorage.setItem("lang", 'fr');
}

export default i18n;
